import { ELanguage } from '@qapline/translations';

export const getLocaleByLanguage = (lang: ELanguage) => {
    switch (lang) {
        case ELanguage.cs:
            return 'cs-CZ';
        case ELanguage.en:
            return 'en-GB';
        case ELanguage.de:
            return 'de-DE';
        default:
            return 'cs-CZ';
    }
};
